// extracted by mini-css-extract-plugin
module.exports = {"EventSummary":"EventSummary_EventSummary__1GVBG"};